(ns motorsaif.web.pages.settings.personal
  (:require
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.string :refer [format]]
   [motorsaif.validation :as validation]
   [motorsaif.web.components :as c]
   [motorsaif.web.lib.form :as form]
   [motorsaif.web.pwa :as pwa]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

(defn user-cars
  []
  (let [user-cars @(subscribe [:user-cars])]
    (when (seq user-cars)
      [:div.user-cars
       [:span.text.title "Cars Added"]
       (into [:ul]
             (map
              (fn [car]
                (let [{id :db/id
                       :car/keys [make model year vin]
                       requests :requests} car
                      {:keys [open closed]} requests]
                  [:li
                   [:div.make (format "%s %s %s" year make model)]
                   (when vin
                     [:div.vin
                      [:span.title "VIN"]
                      [:span.val vin]])
                   [:div.requests
                    [:span
                     [:span.title "Open Requests"]
                     [:span.val open]]
                    [:span
                     [:span.title "Closed Requests"]
                     [:span.val (or closed "0")]]]]))
              (sort-by :date-time/created user-cars)))])))

(defn form []
  (let [user @(subscribe [:user])
        init-data {:user (select-keys @(subscribe [:user])
                                      [:db/id
                                       :user/handle
                                       :user/email
                                       :user/phone])}
        form-key :current-user-profile
        on-submit (fn [{:keys [all-data] :as all}]
                    (let [req {:type :PUT
                               :url "/api/account/profile"
                               :params {:data all-data}
                               :id :update-profile
                               :handler
                               (fn [{:keys [success ex-message] :as res}]
                                 (if success
                                   (rf/dispatch [:toast {:type "success"
                                                         :message "Profile saved!"}])
                                   (rf/dispatch
                                    [:toast {:type "error"
                                             :message (format "Failed to saved %s: " ex-message)}])))
                               :error-handler (fn [res]
                                                (println "Error creating"))}]
                      (rf/dispatch [:do-ajax req])))

        make-form-args
        {:schema validation/edit-profile
         ;; Does not handle valid values
         :change-watch #(dispatch [:reset-form form-key %])
         :on-submit {:valid on-submit
                     :invalid (fn [error]
                                (rf/dispatch
                                 [:toast {:type "error"
                                          :message (format "Please fix the form before submitting")}])

                                (println "Submit error " error))}
         :init-data init-data}
        {:keys [*data form-params input] :as form-args}
        (form/make-form make-form-args)
        admin? @(subscribe [:is-admin?])
        verified (get-in user [:user/status :db/ident])]
    (fn []
      [:form#profile.default
       form-params
       [:div.fields
        [input {:label (tr :forms.edit-profile.username.title)
                :helper (tr :forms.edit-profile.username.description)} [:user :user/handle]]
        [input {:label (tr :forms.edit-profile.name.title)
                :helper (tr :forms.edit-profile.name.description)} [:user :user/name]]
        [input {:label (tr :forms.edit-profile.email.title)
                :helper (tr [:user :status verified])} [:user :user/email]]
        #_(when (= verified :unverified)
            [:button.btn.secondary
             {:type "submit"}
             "Send verification"]
            )
        [input {:label (tr :forms.edit-profile.phone.title)
                :helper (tr :forms.edit-profile.phone.description)} [:user :user/phone]]
        [:br]
        [input {:label (tr :forms.edit-profile.password.change.title)
                :helper (tr :forms.edit-profile.password.change.description)
                :type "password"} [:user :user/password]]
        [input {:label (tr :forms.edit-profile.password.confirm.title)
                :type "password"} [:user :user/password-confirm]]
        [:button.btn.secondary.full
         {:type "submit"}
         (tr :forms.edit-profile.submit.button)]
        [user-cars]]])))

(defn root []
  [:div.content
   [c/header "Profile"]
   [:div.container.med
    {:user-id (:db/id @(subscribe [:user]))}
    [:div.light
     [form]]]])
